<template lang="html">
  <div id="contact-page">
    <section id="contacto" class="py-5 bg-white">
      <div class="container">
        <div class="row">
          <!-- Formulario de contacto -->
          <div class="col-12 col-lg-6 mb-4 mb-lg-0">
            <div class="card border-0 shadow-lg">
              <div class="card-body p-4 p-md-5">
                <h3 class="h3 font-weight-bold mb-4">Solicita tu cotización</h3>

                <b-form @submit.prevent="handleSubmit">
                  <div class="form-row">
                    <b-form-group label="Nombre completo *" label-for="contact-name" class="col-md-6">
                      <b-form-input
                        id="contact-name"
                        v-model.trim="formData.name"
                        type="text"
                        required
                        placeholder="Tu nombre completo"
                      />
                    </b-form-group>

                    <b-form-group label="Teléfono *" label-for="contact-phone" class="col-md-6">
                      <b-form-input
                        id="contact-phone"
                        v-model.trim="formData.phone"
                        type="tel"
                        maxlength="10"
                        required
                        placeholder="+52 55 1234 5678"
                      />
                    </b-form-group>
                  </div>

                  <b-form-group label="Email *" label-for="contact-email">
                    <b-form-input
                      id="contact-email"
                      v-model.trim="formData.email"
                      type="email"
                      required
                      placeholder="tu@email.com"
                    />
                  </b-form-group>

                  <b-form-group label="Empresa*" label-for="contact-company">
                    <b-form-input
                      id="contact-company"
                      v-model.trim="formData.company"
                      type="text"
                      required
                      placeholder="Nombre de tu empresa"
                    />
                  </b-form-group>

                  <b-form-group label="Cuéntanos sobre tu proyecto *" label-for="contact-message">
                    <b-form-textarea
                      id="contact-message"
                      v-model.trim="formData.msg"
                      rows="4"
                      required
                      placeholder="Describe tu proyecto, necesidades específicas, presupuesto estimado..."
                    />
                  </b-form-group>

                  <b-button type="submit" variant="danger" block size="lg" :disabled="disabledButton">
                    Enviar Solicitud
                  </b-button>
                </b-form>
              </div>
            </div>
          </div>

          <!-- Información de contacto -->
          <div class="col-12 col-lg-6">
            <div class="mb-4">
              <h3 class="h3 font-weight-bold mb-3">Información de contacto</h3>
              <p class="text-muted mb-4">
                Estamos aquí para ayudarte. Contáctanos por cualquiera de estos medios y te responderemos en menos de 24
                horas.
              </p>
            </div>

            <div class="row">
              <div
                v-for="(info, index) in contactInfo"
                :key="index"
                class="col-12 col-sm-6 mb-3"
              >
                <div class="card border contact-info-card h-100">
                  <div class="card-body p-4">
                    <div class="d-flex align-items-center mb-3">
                      <div class="contact-info-icon-wrapper mr-3">
                        <i :class="info.iconClass" class="contact-info-icon"></i>
                      </div>
                      <h4 class="h6 font-weight-bold mb-0">{{ info.title }}</h4>
                    </div>
                    <div>
                      <p
                        v-for="(detail, detailIndex) in info.details"
                        :key="detailIndex"
                        class="text-muted small mb-1"
                      >
                        {{ detail }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      disabledButton: false,

      formData: {
        name: '',
        email: '',
        phone: '',
        company: '',
        msg: '',
      },
      
      contactInfo: [
        {
          iconClass: 'fa-solid fa-location-dot',
          title: 'Oficinas Principales',
          details: ['Ciudad de México', 'Guadalajara', 'Monterrey'],
        },
        {
          iconClass: 'fa-solid fa-phone',
          title: 'Teléfono',
          details: ['+52 55 1234 5678', '+52 33 8765 4321'],
        },
        {
          iconClass: 'fa-solid fa-envelope',
          title: 'Email',
          details: ['ventas@ecomexico.net', 'soporte@ecomexico.net'],
        },
        {
          iconClass: 'fa-solid fa-clock',
          title: 'Horarios',
          details: ['Lun - Vie: 9:00 - 18:00', 'Sáb: 9:00 - 14:00'],
        },
      ],
    };
  },
  methods: {
    makeToast(variant = null, msg, title) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
        toaster: 'b-toaster-top-right',
        appendToast: true
      })
    },

    handleSubmit() {
      this.disabledButton = true;
      axios.post(tools.url('/api/contact'), this.formData).then((response) => {
        this.makeToast('success', response.data.response, 'Mensaje enviado');
        this.formData = {
          name: '',
          email: '',
          phone: '',
          company: '',
          msg: '',
        };
        this.disabledButton = false;
      }).catch((error) => {
        // console.log(errors);
        let errors = error.response.data;
        this.makeToast('danger', error.response.data.name, 'Error');
        this.makeToast('danger', error.response.data.phone, 'Error');
        this.makeToast('danger', error.response.data.email, 'Error');
        this.makeToast('danger', error.response.data.company, 'Error');
        this.makeToast('danger', error.response.data.msg, 'Error');
        this.disabledButton = false;
      });      
    },
  },
};
</script>